export default __webpack_public_path__ + "static/media/index-last2.93e6cfe0.png";